// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_orthohouse_about = /** @type {(inputs: {}) => string} */ () => {
	return `Healthy Shoes is part of OrthoHouse, the orthopaedic, mobility and home-care shop.`
};

const el_orthohouse_about = /** @type {(inputs: {}) => string} */ () => {
	return `Το Healthy Shoes ανήκει στην OrthoHouse, κατάστημα για ορθοπεδικά είδη, βοηθήματα κινητικότητας και φροντίδα στο σπίτι.`
};

const ru_orthohouse_about = /** @type {(inputs: {}) => string} */ () => {
	return `Healthy Shoes — часть OrthoHouse, магазина ортопедических товаров, средств реабилитации и товаров для ухода на дому.`
};

const he_orthohouse_about = /** @type {(inputs: {}) => string} */ () => {
	return `האתר Healthy Shoes הוא חלק מ־OrthoHouse, חנות למוצרים אורתופדיים, עזרי ניידות וטיפול ביתי.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const orthohouse_about = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.orthohouse_about(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("orthohouse_about", locale)
	if (locale === "en") return en_orthohouse_about(inputs)
	if (locale === "el") return el_orthohouse_about(inputs)
	if (locale === "ru") return ru_orthohouse_about(inputs)
	if (locale === "he") return he_orthohouse_about(inputs)
	return "orthohouse_about"
};